





























import { Component, Vue } from 'vue-property-decorator';
import Login from './views/Login.vue';
import user from '@/store/modules/user';
import version from '@/store/modules/version';
import alert from '@/store/modules/alert';
import IconSet from '@/components/IconSet.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import InfoModal from '@/components/InfoModal.vue';
import WelcomeModal from '@/components/WelcomeModal.vue';
import {User} from '@/store/models';
import Bowser from 'bowser';
import GlobalSpinner from '@/components/GlobalSpinner.vue';

@Component({
  components: {GlobalSpinner, IconSet, Login, ErrorModal, InfoModal, WelcomeModal},
})
export default class App extends Vue {
  initiated: boolean = false;
  fullscreen: boolean = false;

  onFullscreenChange() {
    this.fullscreen = !this.fullscreen;
    let route = this.$router.currentRoute.name;
    if (!route) {
        route = '';
    }
    if (!this.fullscreen && route.startsWith('presentation-')) {
      this.$router.back();
    }
  }

  async mounted() {
    if (!this.supportedBrowser) { return; }

    if (user.user === null) {
      await user.getUser('Hämtar bolagsdata');
      this.initiated = true;
    }
    window.setInterval( () => version.getVersion(), 60 * 1000);
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
    document.addEventListener('msfullscreenchange', this.onFullscreenChange);
  }

  closeError() {
      alert.setError(null);
  }

  get supportedBrowser() {
    return !Bowser.msie;
  }

  get pendingFetch() {
    return user.fetchingData;
  }

  get user(): User | null {
    return user.user;
  }

  get error(): any {
    return alert.error;
  }

}
